// 深連結開到目前範圍外的設備 / 事件時，頁頂的提示（P0-2、SPEC #vms-web-220 深連結不受範圍限制）：
// 「這台設備在 EddyStudio › lab，不在目前的範圍（LivingStyle）。〔把範圍切到 lab〕」
import { useTranslation } from 'react-i18next';
import { useScope } from '../lib/scope';
import { nodePath } from '../lib/myDevices';
import { scopeNodeName } from '../features/shell/Shell';

export function OutOfScopeHint({ homeId, kind }: { homeId: string; kind: 'device' | 'event' }) {
  const { t } = useTranslation();
  const { scope, tree, homes, setScope, scopeLabel } = useScope();
  const key = 'home:' + homeId;
  const path = nodePath(tree, key)
    .filter((n) => n.kind !== 'source')
    .map((n) => scopeNodeName(t, n))
    .join(' › ');
  const home = homes.find((h) => h.home_id === homeId);
  const homeName = home?.display_name || homeId;
  const cur = tree.find((n) => n.key === scope);
  const curName = scope === 'all' ? t('scope.hint_all') : cur ? scopeNodeName(t, cur) : scopeLabel || t('ot.scope_custom');
  const canSwitch = tree.some((n) => n.key === key);
  return (
    <p className="card scope-hint" role="status" data-testid="out-of-scope">
      {t(kind === 'device' ? 'scope.hint_device' : 'scope.hint_event', { path: path || homeName, scope: curName })}{' '}
      {canSwitch && (
        <button className="btn btn-sm" onClick={() => setScope(key, '', { announce: t('scope.switched_to', { name: path || homeName }) })} data-testid="out-of-scope-switch">
          {/* 按鈕寫完整路徑〔把範圍切到 EddyStudio › lab〕（第八輪 B8-06：LivingStyle › lstw 也有 lab） */}
          {t('scope.hint_switch', { name: path || homeName })}
        </button>
      )}
    </p>
  );
}
